const EmptyNewCryptoTransaction = () => (
  <div className="flex h-[300px] flex-col items-center justify-center px-6 text-center">
    <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-background-surface border border-divider">
      <svg
        className="h-8 w-8 text-text-secondary"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="4"
          y="3"
          width="16"
          height="18"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="M8 8H16"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M8 12H13"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M8 16H11"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M16.5 15L18 16.5L20.5 14"
          stroke="#4AB932"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>

    <h3 className="text-base font-semibold text-text-primary">
      No Transactions Yet
    </h3>

    <p className="mt-2 max-w-[280px] text-sm leading-6 text-text-secondary">
      Your deposits, withdrawals, transfers, and trades will appear here once
      you complete your first transaction.
    </p>
  </div>
);


export default EmptyNewCryptoTransaction;